import { create } from "zustand"

export type BuyerNavItem =
  | "dashboard"
  | "explore"
  | "browse-products"
  | "browse-supplier"
  | "rfqs"
  | "quotations"
  | "orders"
  | "logistics"
  | "settings"
  | "profile"
  | "submit-rfq"
  | "complaints"
  | "notifications"

interface BuyerUIState {
  activeNav: BuyerNavItem
  scrolledPastHero: boolean
  setActiveNav: (nav: BuyerNavItem) => void
  setScrolledPastHero: (val: boolean) => void
}

export const useBuyerUIStore = create<BuyerUIState>((set) => ({
  activeNav: "dashboard",
  scrolledPastHero: false,
  setActiveNav: (activeNav) => set({ activeNav }),
  setScrolledPastHero: (scrolledPastHero) => set({ scrolledPastHero }),
}))
